/** Préfixes des droppableIds (un seul DragDropContext dans BriquesSection). */

export const BRIQUES_ORDER_TYPE = "BRIQUES_ORDER";

export const briquesOrderDroppableId = (orderDndKey) =>
  `briques-devis-order-${orderDndKey}`;

export const briqueItemsDroppableIdFor = (brique) =>
  `brique-items-${brique._devisId || brique.id || "new"}`;

export const forfaitSegmentsDroppableId = (briqueDevisId, itemLocalId) =>
  `forfait-segments__${briqueDevisId}__${itemLocalId}`;

export const groupSegmentsDroppableId = (briqueDevisId, itemLocalId) =>
  `group-segments__${briqueDevisId}__${itemLocalId}`;

export const articleSegmentsDroppableId = (briqueDevisId, itemLocalId) =>
  `article-segments__${briqueDevisId}__${itemLocalId}`;

/** draggableId des lignes dans une brique (unicité globale). */
export const briqueLineDraggableId = (briqueDevisId, itemLocalId) =>
  `${briqueDevisId}::${itemLocalId}`;

export const briqueCardDraggableId = (briqueDevisId) =>
  `brique-card-${briqueDevisId}`;
